module.exports = __webpack_public_path__ + "img/bg2.8583760d.png";